/*
  Obsługa przycisków "Dodaj" w sekcji propozycji w koszyku (snippet cart-upsell.liquid).

  Zdarzenia są delegowane na document, bo zawartość .drawer__inner jest podmieniana
  przez cart.js po każdej zmianie koszyka — nasłuchiwacze wpięte w środek drawera
  nie przetrwałyby tej podmiany.
*/
(function () {
  if (window.__cartUpsellInit) return;
  window.__cartUpsellInit = true;

  async function refreshCartDrawer() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    // cart-drawer jest snippetem renderowanym w layout/theme.liquid, nie sekcją,
    // więc ?section_id=cart-drawer zwraca pustą odpowiedź — bierzemy bieżącą stronę.
    var separator = window.location.href.indexOf('?') === -1 ? '?' : '&';
    var response = await fetch(window.location.href + separator + '_=' + Date.now(), { cache: 'no-store' });
    var html = await response.text();

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var sourceDrawer = doc.querySelector('cart-drawer');

    var wasOpen = cartDrawer.classList.contains('active');
    var sourceInner = sourceDrawer && sourceDrawer.querySelector('.drawer__inner');
    var targetInner = cartDrawer.querySelector('.drawer__inner');
    if (sourceInner && targetInner) targetInner.innerHTML = sourceInner.innerHTML;
    if (sourceDrawer) cartDrawer.className = sourceDrawer.className;

    if (wasOpen) {
      cartDrawer.classList.add('animate', 'active');
      document.body.classList.add('overflow-hidden');
    }

    syncAllScrollIndicators();
  }

  function refreshCartBadge() {
    var badge = document.getElementById('cart-count-badge');
    if (!badge) return;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count || 0;
        badge.textContent = count;
        badge.setAttribute('aria-label', count > 0 ? count + ' produktów w koszyku' : 'Koszyk');
        if (count > 0) badge.classList.remove('hidden');
        else badge.classList.add('hidden');
      })
      .catch(function () {});
  }

  // --- Wskaźnik przewijania karuzeli propozycji ---
  function syncScrollIndicator(scroller) {
    var container = scroller.closest('.cart-upsell');
    var progress = container && container.querySelector('[data-cart-upsell-progress]');
    var thumb = progress && progress.querySelector('[data-cart-upsell-progress-thumb]');
    if (!progress || !thumb) return;

    var scrollable = scroller.scrollWidth - scroller.clientWidth;
    if (scrollable <= 4) {
      progress.classList.remove('is-visible');
      return;
    }

    progress.classList.add('is-visible');

    // szerokość kciuka proporcjonalna do widocznej części listy
    var ratio = scroller.clientWidth / scroller.scrollWidth;
    var thumbPercent = Math.max(ratio * 100, 25);
    thumb.style.width = thumbPercent + '%';

    var progressed = scroller.scrollLeft / scrollable;
    var travel = 100 - thumbPercent;
    thumb.style.transform = 'translateX(' + progressed * travel / thumbPercent * 100 + '%)';
  }

  function syncAllScrollIndicators() {
    document.querySelectorAll('.cart-upsell__scroller').forEach(syncScrollIndicator);
  }

  // scroll wewnątrz karuzeli nie bąbelkuje — łapiemy go w fazie przechwytywania,
  // dzięki czemu działa też po podmianie zawartości drawera
  document.addEventListener('scroll', function (event) {
    var scroller = event.target;
    if (scroller && scroller.classList && scroller.classList.contains('cart-upsell__scroller')) {
      syncScrollIndicator(scroller);
    }
  }, true);

  window.addEventListener('resize', syncAllScrollIndicators);
  document.addEventListener('DOMContentLoaded', syncAllScrollIndicators);

  function showError(button, message) {
    var container = button.closest('.cart-upsell');
    var errorEl = container && container.querySelector('.cart-upsell__error');
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.classList.remove('hidden');
  }

  document.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-cart-upsell-add]');
    if (!button) return;

    event.preventDefault();

    var variantId = parseInt(button.getAttribute('data-variant-id'), 10);
    if (!variantId) {
      showError(button, 'Nie udało się dodać produktu.');
      return;
    }

    var originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Dodaję...';

    try {
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });
      var data = await response.json();

      if (!response.ok) {
        button.disabled = false;
        button.textContent = originalText;
        showError(button, data.description || data.message || 'Nie udało się dodać produktu.');
        return;
      }

      refreshCartBadge();
      await refreshCartDrawer();
    } catch (error) {
      button.disabled = false;
      button.textContent = originalText;
      showError(button, 'Nie udało się dodać produktu.');
      console.error('Upsell w koszyku:', error);
    }
  });
})();
